import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;

  min-width: 100%;
  max-width: 100%;
  width: 100%;

  overflow: hidden;
`

export const HeaderContainer = styled.div`
  background: var(--Background-Page-faded, #fafafa);
  height: 44px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  padding: 0px 16px;
  box-sizing: border-box;
`

export const HeaderFolderContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  max-width: calc(100% / 4);
`

export const HeaderLabel = styled.label`
  cursor: pointer;

  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.picked {
    cursor: default;

    font-weight: 700;
  }
`

export const ScrollContainer = styled.div`
  overflow: hidden;

  display: flex;
  flex-direction: row;

  height: calc(36px * 6);

  min-width: 100%;
  max-width: 100%;
  width: 100%;
`

export const ListContainter = styled.div`
  overflow: hidden;

  min-width: 100%;
  max-width: 100%;
  width: 100%;
`

export const RowContainer = styled.div<{ isClickable?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 36px;

  &.file {
    opacity: ${({ isClickable }) => (isClickable ? 1 : 0.5)};
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
    background-color: white;

    div {
      cursor: default;
      background-color: white;
    }
  }
`

export const RowInfoContainer = styled.div<{ selected?: boolean; disabled?: boolean }>`
  flex: 1;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'cursor')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  height: 36px;

  padding: 0px 0px 0px 16px;
  box-sizing: border-box;

  background: ${({ selected }) => (selected ? 'var(--Background-Neutral, #dfe2ea66)' : 'white')};

  &:hover {
    background: ${({ disabled }) => (disabled ? 'white' : 'var(--Background-Neutral, #dfe2ea66)')};
  }
`

export const RowIconContainer = styled.div`
  width: 24px;
  height: 24px;
`

export const RowLabelContainer = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  /* Body 3/Medium */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ArrowContainer = styled.div`
  cursor: pointer;

  width: 44px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--Background-Neutral, #dfe2ea66);
  }
`

export const FilePreview = styled.img`
  width: 24px;
  height: 24px;

  border-radius: 2px;
`
